import { replace } from '../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import Translation from '../translation/translation';

function Suggestion({ translationKey, placeholder, onClick }) {
    return (
        <div className="no-results__suggestion no-results-suggestion" onClick={onClick}>
            <Translation
                translationKey={translationKey}
                placeholder={placeholder}
                formatter={replace.bind(this, /: 1$/, '')}
                className="no-results-suggestion__suggestion"
            />
        </div>
    );
}

Suggestion.propTypes = {
    translationKey: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    placeholder: PropTypes.object,
};

Suggestion.defaultProps = {
    placeholder: {},
};

export { Suggestion };
